// extracted by mini-css-extract-plugin
export default {"site-footer":"Footer_site-footer__Dmlfp","contact-info":"Footer_contact-info__Fozfm","footer-links":"Footer_footer-links__ttWjy"};